var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Entity } from '@decahedron/entity';
import { asset } from './util';
var MediaAsset = /** @class */ (function (_super) {
    __extends(MediaAsset, _super);
    function MediaAsset() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.companyId = null;
        _this.createdAt = null;
        _this.duration = null;
        _this.fileSize = null;
        _this.height = null;
        _this.width = null;
        _this.isLocal = null;
        _this.originalName = null;
        _this.parentId = null;
        _this.ratio = null;
        _this.title = null;
        _this.type = null;
        _this.updatedAt = null;
        _this.fullUrl = null;
        _this.uri = null;
        _this.uuid = null;
        return _this;
    }
    Object.defineProperty(MediaAsset.prototype, "url", {
        get: function () {
            return this.fullUrl || this.uri;
        },
        enumerable: false,
        configurable: true
    });
    MediaAsset.prototype.cdn = function (width, height, fm) {
        if (fm === void 0) { fm = 'webp'; }
        var options = { fm: fm, width: width };
        if (height) {
            options = __assign(__assign({}, options), { height: height });
        }
        return asset(this.url, options);
    };
    return MediaAsset;
}(Entity));
export { MediaAsset };
